module.exports = __webpack_public_path__ + "img/mensagem.5628d74f.svg";